module.exports = __webpack_public_path__ + "img/vip.3473ef66.svg";